const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const Promises = {
    delay,
}

export default Promises;